// const apiUrlAddress = 'http://localhost/ramjaninteriors/';
const apiUrlAddress = 'https://ramjaninteriors.com/';
const apiToken = '$2y$10$z9qsFg2piZUeKYd9FaRsseRyj6r5unapljJqlstjROD1Wlf/90nza';

export {
    apiUrlAddress,
    apiToken
};